import { Button, Row, Space, Typography, Col, Tag } from 'antd';
import { useMemo, useState } from 'react';
import { CASH_ID, CountryEnum, DD_MM_YYYY_H_MM, Employee, FINAL_INVOICE_TEXT, GROSS_AMOUNT_TEXT, RTO, SENT_FOR_INVOICING, UserEnum, isAccessible, isProdMode } from '../../../../../utils/app-common';
import { useManifestContextHook } from './Context/useManifestContextHook';
import GenerateInvoiceHook from './hooks/GenerateInvoiceHook';
import RevalidateHook from './hooks/RevalidateHook';
import { convertDateFromMillis } from '../../../../../utils/luxon';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';


type IButtonComponent = {
    form: Readonly<any>,
}

function ButtonComponent({ form }: IButtonComponent) {


    const { billTypeId, isOracleInvoiced, isDelivered, deliveryId, lastStatus, sentForOracleInvoicing, isInternational, fromOperation,
        modifiedByEmp, manifestedUpdatedDate, confirmedBySalesperson, salespersonConfirmedDate, isSalesmanApproved, isSalesmanRejected,
        rejectedBySalesmanName, salesmanRejectionRemarks, salesmanRejectionDate, confirmedByFinance, financeConfirmedDate, isFinanceRejected,
        isFinanceApproved, rejectedByFinance, financeRejectionDate, financeRejectionRemarks, isInvoicedManifest: isInvoiced, isInternationalRangeProduct, consigneeUpdated, readOnly } = useManifestContextHook();
    const isManifestDelivered = ((deliveryId! > 0) || isDelivered);
    const { reValidateHandle } = RevalidateHook();
    const { generateInvoiceHandle } = GenerateInvoiceHook();
    // const isInvoiced = form?.getFieldValue('isInvoiced');
    const grossAmount = form?.getFieldValue('grossCharge');
    const hasManifestDetailsAccess = isAccessible([UserEnum.MANAGER, UserEnum.MANIFESTER, UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER, UserEnum.SALES_MANAGER], [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA]);
    const hasManifestationBtnAccess = isProdMode() ? isAccessible([Employee.IMATHUL_RAFI], [CountryEnum.UAE], true) : false;

    const [showGrossError, setShowGrossError] = useState(false)


    // const { state } = useLocation();
    // const { productName, assignVehicle: assignedVehicleId, waybillNo } = state || {};
    // const GetFleetInformationAction = useOperationStore((state) => state?.GetFleetInformationAction);
    // const fleetResponse = useOperationStore((state) => state?.fleetResponse);
    // const [vehicleNumber, setVehicleNumber] = useState<string | number | undefined>();
    // const [vehicleType, setVehicleType] = useState<string | number | undefined>();
    // const [cost, setCost] = useState<string | number | undefined>();
    // const [supplierName, setSupplierName] = useState<string | number | undefined>();

    // const [showFTLError, setShowFTLError] = useState(false)

    // useEffect(() => {
    //     GetFleetInformationAction(waybillNo);
    // }, []);

    // useEffect(() => {
    //     if (fleetResponse && Object?.values(fleetResponse)?.length) {

    //             for (const [key, values] of Object.entries(fleetResponse)) {
    //                 if (key === 'fleetInformation') {
    //                     for (const [key, value] of Object.entries(values)) {
    //                         if (key?.includes('vehicleNumber')) {
    //                             setVehicleNumber(value);
    //                         }
    //                         if (key?.includes('vehicleType')) {
    //                             setVehicleType(value);
    //                         }
    //                         if (key?.includes('cost')) {
    //                             setCost(value);
    //                         }
    //                         if (key?.includes('supplierName')) {
    //                             setSupplierName(value);
    //                         }
    //                     }
    //                 }
    //             };

    //     }

    // }, [fleetResponse]);

    // useEffect(() => {
    //     onFtlProductTypeCheck();
    // }, [fleetResponse, waybillNo, productName, assignedVehicleId, vehicleNumber, vehicleType, cost, supplierName]);


    // const onFtlProductTypeCheck = () => {

    //     if ( FtlProductTypeNames?.includes(productName) && assignedVehicleId === VehicleTypeIds.AD_HOC && (vehicleType === undefined || vehicleNumber === undefined || cost === undefined || supplierName === undefined) ) {
    //         setShowFTLError(true);
    //         return;
    //     }
    //         setShowFTLError(false);
    // };




    //TODO: Use this instead of ternary operator for disabling btn.
    //INFO: 1. Disable manifester confirmed btn if isOracleInvoiced and for rest,
    //INFO: 2. Enable btn if isManifestDelivered, and lastStatus is RTO;
    //INFO :3. If the Account Type is CASH, then no need to check for is Delivered for Manifester Confirmed;
    const isButtonDisabled = () => {
        if (billTypeId && [CASH_ID].includes(billTypeId)) return false;
        if (isOracleInvoiced) return true;
        if (sentForOracleInvoicing) return true;
        if (isInternational && isInvoiced && isSalesmanApproved) return true;
        if (lastStatus && [RTO].includes(lastStatus)) return false;
        if (isManifestDelivered) return false;
        return true;
    };

    const onManifestConfirmHandler = () => {
        if (!isInternational && !grossAmount) {
            setShowGrossError(true);
            return;
        }
        generateInvoiceHandle()
    };
    // const onHidden = () => {
    //     return (billTypeId) ? [CASH_ID].includes(billTypeId) : false
    // }
    const isCashAccount = billTypeId ? [CASH_ID].includes(billTypeId) : false;

    return (
        <Row align='bottom' className='margin-top-1rem' hidden={!fromOperation || readOnly}>
            {
                consigneeUpdated ? (
                    <Col span={24} style={{ textAlign: 'center' }}>
                        <Typography.Text strong type='danger'>
                            <Typography.Title level={5} type='danger'>*This waybill has undergone a consignee change. Please check with the Sales team and apply any required changes.*</Typography.Title>
                        </Typography.Text>
                    </Col>
                ) : null
            }

            <Col span={18}>
                {/* isInvoiced is true when manifestor confirms but reverts back to false when salesman or finance rejects.
                    So, to show status details, isSalesmanRejected & isFinanceRejected checks are added*/}
                {isInternational && (isInvoiced || isSalesmanRejected || isFinanceRejected) ? <>
                    <Row>
                        <Col offset={6} span={6}><Typography.Text strong>Manifester</Typography.Text></Col>
                        {!isInternationalRangeProduct && <Col span={6}><Typography.Text strong>Salesperson</Typography.Text></Col>}
                        {!isInternationalRangeProduct && <Col span={6}><Typography.Text strong>Finance</Typography.Text></Col>}

                    </Row>
                    <Row>
                        <Col span={6}><Typography.Text strong>User</Typography.Text></Col>
                        <Col span={6}><Typography.Text>{modifiedByEmp}</Typography.Text></Col>
                        <Col span={6}>
                            <Typography.Text>
                                {isSalesmanRejected ? rejectedBySalesmanName : (isSalesmanApproved ? confirmedBySalesperson : "")}
                            </Typography.Text>
                        </Col>
                        <Col span={6}>
                            <Typography.Text>
                                {isFinanceRejected ? rejectedByFinance : (isFinanceApproved ? confirmedByFinance : "")}
                            </Typography.Text>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={6}><Typography.Text strong>Status</Typography.Text></Col>
                        <Col span={6}>
                            {modifiedByEmp ? <Tag icon={<CheckCircleOutlined />} color="success">Confirmed</Tag> : null}
                        </Col>
                        <Col span={6}>
                            {isSalesmanRejected ?
                                <Tag icon={<CloseCircleOutlined />} color="error">Rejected*</Tag> :
                                (isSalesmanApproved ? <Tag icon={<CheckCircleOutlined />} color="success">Confirmed</Tag> :
                                    null)}
                        </Col>
                        <Col span={6}>
                            {isFinanceRejected ?
                                <Tag icon={<CloseCircleOutlined />} color="error">Rejected*</Tag> :
                                (isFinanceApproved ? <Tag icon={<CheckCircleOutlined />} color="success">Confirmed</Tag> :
                                    null)}
                        </Col>
                    </Row>
                    <Row>
                        <Col span={6}><Typography.Text strong>Date</Typography.Text></Col>
                        <Col span={6}><Typography.Text>{convertDateFromMillis(manifestedUpdatedDate, DD_MM_YYYY_H_MM)}</Typography.Text></Col>
                        <Col span={6}>
                            <Typography.Text>
                                {isSalesmanRejected ? convertDateFromMillis(salesmanRejectionDate, DD_MM_YYYY_H_MM) :
                                    (isSalesmanApproved ? convertDateFromMillis(salespersonConfirmedDate, DD_MM_YYYY_H_MM) : "")}
                            </Typography.Text>
                        </Col>
                        <Col span={6}>
                            <Typography.Text>
                                {isFinanceRejected ? convertDateFromMillis(financeRejectionDate, DD_MM_YYYY_H_MM) :
                                    (isFinanceApproved ? convertDateFromMillis(financeConfirmedDate, DD_MM_YYYY_H_MM) : "")}
                            </Typography.Text>
                        </Col>
                    </Row>
                    <Row hidden={!((isFinanceRejected && financeRejectionRemarks) || (isSalesmanRejected && salesmanRejectionRemarks))}>
                        <Col offset={6} span={18}>
                            <Typography.Text type="danger">*{
                                isFinanceRejected ? financeRejectionRemarks :
                                    (isSalesmanRejected ? salesmanRejectionRemarks : "")
                            }</Typography.Text>
                        </Col>
                    </Row>
                </> : null}
            </Col>
            <Col span={6}>
                <Space direction='vertical' size={'middle'} >
                    <Typography.Text strong type='danger'>
                        {isOracleInvoiced ? FINAL_INVOICE_TEXT : ''}
                    </Typography.Text>
                    <Typography.Text strong type='danger'>
                        {showGrossError ? GROSS_AMOUNT_TEXT : ''}
                    </Typography.Text>
                    <Typography.Text strong type='danger'>
                        {sentForOracleInvoicing ? SENT_FOR_INVOICING : ''}
                    </Typography.Text>
                    { /**
                    <Typography.Text strong type='danger'>
                        {showFTLError ? EMPTY_VEHICLE_TYPE_AND_VEHICLE_NUMBER_AND_COST_AND_SUPPLIER_TEXT : ''}
                    </Typography.Text>
                    */}
                    {(hasManifestDetailsAccess || hasManifestationBtnAccess) ?
                        <Space wrap>
                            <Button disabled={isOracleInvoiced || sentForOracleInvoicing} data-args={'validate'} type='primary' htmlType="button"
                                onClick={() => reValidateHandle(form)}>
                                {'Validate'}
                            </Button>
                            <Button disabled={isButtonDisabled()}
                                data-args={'invoice'} danger={isInvoiced} type='primary'
                                htmlType="button" onClick={onManifestConfirmHandler} >
                                {'Manifester Confirmed'}
                            </Button>
                            <Button disabled={isOracleInvoiced || sentForOracleInvoicing || isInvoiced} hidden={isCashAccount}
                                data-args={'save&close'} type='primary' htmlType="submit" >
                                {'Save'}
                            </Button>
                        </Space>
                        : null}
                </Space>
            </Col>
        </Row>
    )
}

export default ButtonComponent